import { render, staticRenderFns } from "./proc.vue?vue&type=template&id=9c3b3b96&"
import script from "./proc.vue?vue&type=script&lang=js&"
export * from "./proc.vue?vue&type=script&lang=js&"
import style0 from "./proc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports